var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 11.3636C24.5002 17.3635 19.6364 22.2273 13.6366 22.2273C7.63677 22.2273 2.77295 17.3635 2.77295 11.3636C2.77295 5.36382 7.63677 0.5 13.6366 0.5C19.6364 0.5 24.5002 5.36382 24.5002 11.3636Z",
    fill: "url(#paint0_linear_3345_910)",
    stroke: "#F9BA0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2273 11.3636C20.2273 16.2589 16.2589 20.2273 11.3636 20.2273C6.46839 20.2273 2.5 16.2589 2.5 11.3636C2.5 6.46839 6.46839 2.5 11.3636 2.5C16.2589 2.5 20.2273 6.46839 20.2273 11.3636Z",
    fill: "#F9BA0F",
    stroke: "#F9BA0F",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3496 16.6954L10.9954 16.5962L10.5703 16.3696L10.2586 16.1712L9.93279 15.9445L9.47943 15.6612L9.06857 15.3778L8.5727 14.9953L7.82181 14.3294L7.35428 13.8902L6.98592 13.5219L6.66007 13.0968L6.39088 12.601L6.2492 12.3743L6.1642 12.1901L6.03669 11.7367L5.95168 11.4392L5.90918 11.2409V10.7025V10.235L6.02252 9.90911L6.30587 9.35657L6.70257 8.7757L7.1276 8.43568L7.6093 8.06732L8.07683 7.8548L8.5727 7.72729H9.1394L9.4936 7.78397L9.91862 7.91147L10.372 8.06732L10.712 8.23733L11.0379 8.43568L11.2646 8.63402L11.3779 8.71903L11.4629 8.63402L11.6754 8.43568L11.9446 8.23733L12.228 8.06732L12.6105 7.91147L13.0213 7.78397L13.4605 7.72729H13.9989L14.5656 7.8548L15.1182 8.06732L15.6849 8.43568L16.0391 8.7757L16.4216 9.2574L16.7049 9.90911L16.8183 10.3908V11.0992V11.34L16.5774 12.1334L16.1099 13.0118L15.7132 13.536L15.0473 14.2444L14.2256 14.9386L12.1713 16.3696L11.7463 16.5962L11.3496 16.6954Z",
    fill: "#6B520D",
    stroke: "#6B520D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3345_910",
    x1: 13.6366,
    y1: 2.15898e-7,
    x2: 16.8184,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272092,
    stopColor: "#6B520D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B520D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToken);
export default __webpack_public_path__ + "static/media/icon-token.526c869a67724e99a65dbbf13fd81719.svg";
export { ForwardRef as ReactComponent };